"use strict";
exports.__esModule = true;
exports.TutorEventing = exports.UserEventing = void 0;
exports.UserEventing = require("./generated/event-schema");
exports.TutorEventing = require("./generated/tutor-event-schema");
//# sourceMappingURL=index.js.map